// src/modal/modal-context.tsx
import {
  createContext,
  useReducer,
  useContext,
  useCallback,
  useMemo
} from "react";
import { jsx } from "react/jsx-runtime";
function createModalContext() {
  const initialState = {
    type: null,
    props: {}
  };
  const ModalContext = createContext(void 0);
  function modalReducer(state, action) {
    switch (action.type) {
      case "OPEN_MODAL":
        return { ...action.payload };
      case "CLOSE_MODAL":
        return { ...initialState };
      default:
        return state;
    }
  }
  const ModalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(modalReducer, initialState);
    const openModal = useCallback(
      (type, props) => {
        dispatch({
          type: "OPEN_MODAL",
          payload: { type, props }
        });
      },
      []
    );
    const closeModal = useCallback(() => {
      dispatch({ type: "CLOSE_MODAL" });
    }, []);
    const isModalOpen = useCallback(() => state.type !== null, [state.type]);
    const contextValue = useMemo(
      () => ({
        modalState: state,
        openModal,
        closeModal,
        isModalOpen
      }),
      [state, openModal, closeModal, isModalOpen]
    );
    return /* @__PURE__ */ jsx(ModalContext.Provider, { value: contextValue, children });
  };
  const useModal = () => {
    const context = useContext(ModalContext);
    if (context === void 0) {
      throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
  };
  return { ModalProvider, useModal, ModalContext };
}

// src/modal/modal-route-resetter.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function ModalRouteResetter({ useModal }) {
  const location = useLocation();
  const { closeModal } = useModal();
  useEffect(() => {
    closeModal();
  }, [location.pathname]);
  return null;
}

export {
  createModalContext,
  ModalRouteResetter
};
